import React from 'react';
import {
  Link,
} from '@mui/material';

export default function OHQueueHeader() {
  return (
    <Link variant="h6" color="#FFFFFF" fontWeight='bold' href="" underline="none" sx={{pt: 0.3}}>
      10-301/601 Office Hours Queue
    </Link>
  );
}
